export class RichiestaMutuoCambioStato {

    constructor(
        public nuovoStato: string,
        public idRichiesta: number,
        public note: string
    ) { }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/richiesta-mutuo-cambio-stato.ts